import env from './env';

const ONE_SECOND = 1000;
const FIVE_SECONDS = 5000;
const TEN_SECONDS = 10_000;

export const filesQueryPollInterval = {
  DEFAULT: env.app.defaults?.pollIntervalOverride || TEN_SECONDS,
  ONE_SECOND: env.app.defaults?.pollIntervalOverride || ONE_SECOND,
  FIVE_SECONDS: env.app.defaults?.pollIntervalOverride || FIVE_SECONDS,
};

export const fileQueryPollInterval = {
  DEFAULT: env.app.defaults?.pollIntervalOverride || TEN_SECONDS,
  ONE_SECOND: env.app.defaults?.pollIntervalOverride || ONE_SECOND,
  FIVE_SECONDS: env.app.defaults?.pollIntervalOverride || FIVE_SECONDS,
};

export const dltNodeListPollInterval = {
  DEFAULT: env.app.defaults?.pollIntervalOverride || TEN_SECONDS,
};
